import createReducer from '../../../data/shared/createReducer';
import { SUBMITTING_SIGN_IN, SIGN_IN_FAILURE, SIGN_IN_SUCCESS, RESET_SIGN_IN } from '../constants/action_types';

const initialState = {
    error: null
};

const submittingSignIn = (state, action) => ({
    ...initialState
});

const signInFailure = (state, action) => ({
    ...state,
    error: 'error'
});

const signInSuccess = (state, action) => ({
    ...state,
    error: null
});

const resetSignIn = (state, action) => ({
    ...initialState
});

const signInReducer = createReducer(initialState, {
    [SUBMITTING_SIGN_IN]: submittingSignIn,
    [SIGN_IN_SUCCESS]: signInSuccess,
    [SIGN_IN_FAILURE]: signInFailure,
    [RESET_SIGN_IN]: resetSignIn
});

export default signInReducer;
